module.exports = __webpack_public_path__ + "media/assets/images/blog/beta_features_introduction-8513f3c495545b278aee4af135d3acdd.png";